<template>
  <section class="index-quote-details">
    <div class="quote-summary"><div><span>最新价</span><strong :class="quoteClass(stock.px_change_rate)">{{ priceDisplay(stock.last_px) }}</strong></div><div><span>涨跌幅</span><strong :class="quoteClass(stock.px_change_rate)">{{ signed(stock.px_change_rate, '%') }}</strong></div><div><span>涨跌额</span><strong :class="quoteClass(stock.px_change)">{{ priceDisplay(stock.px_change) }}</strong></div></div>
    <dl><div v-for="field in shownFields" :key="field.key"><dt>{{ field.title }}</dt><dd :class="fieldClass(field.key)">{{ detailDisplay(details[field.key], field.key) }}</dd></div></dl>
    <div class="detail-controls"><button type="button" :aria-expanded="expanded" @click="expanded = !expanded">{{ expanded ? '收起指标 ▴' : '展开全部指标 ▾' }}</button></div>
  </section>
</template>
<script>
import { quoteDisplay, quoteNumber, quotePrice } from '@/utils/quoteDisplay'
import { indexQuoteClass } from './indexTrade'
import { indexDetailsFromQuote, indexDetailDisplay } from './indexQuoteDetails'
export default {
  props: { stock: { type: Object, required: true }, quote: Object },
  data: () => ({ expanded: false, fields: [
    { key: 'open', title: '今开' }, { key: 'high', title: '最高' }, { key: 'vol', title: '成交量' },
    { key: 'yclose', title: '昨收' }, { key: 'low', title: '最低' }, { key: 'amount', title: '成交额' },
    { key: 'up', title: '涨家' }, { key: 'unchanged', title: '平家' }, { key: 'down', title: '跌家' },
    { key: 'exchangerate', title: '换手率' }, { key: 'pe2', title: '市盈(TTM)' }, { key: 'flowmarketvalue', title: '流通市值' },
    { key: 'volratio', title: '量比' }, { key: 'amplitude', title: '振幅' }, { key: 'marketvalue', title: '总市值' },
    { key: 'bookrate', title: '委比' }, { key: 'week1', title: '52周高' }, { key: 'week4', title: '52周低' },
    { key: 'week13', title: '5日' }, { key: 'week26', title: '20日' }, { key: 'week52', title: '年初至今' }
  ] }),
  computed: {
    details() { return this.quote && this.quote.code === this.stock.full_code ? indexDetailsFromQuote(this.quote.info, this.quote.breadth, this.stock.full_code) || {} : {} },
    shownFields() { return this.expanded ? this.fields : this.fields.slice(0, 6) }
  },
  methods: {
    display: quoteDisplay, priceDisplay: quotePrice, quoteClass: indexQuoteClass,
    detailDisplay(value, field) { return indexDetailDisplay(value, field, this.stock.full_code) },
    signed(value, suffix = '') { return quoteDisplay(value, suffix, 1, 2) },
    fieldClass(field) {
      const value = quoteNumber(this.details[field]), close = quoteNumber(this.details.yclose)
      if (value == null) return ''
      if (['open', 'high', 'low'].includes(field)) return close == null ? '' : indexQuoteClass(value - close)
      if (field === 'volratio') return indexQuoteClass(value - 1)
      if (['week13', 'week26', 'week52'].includes(field)) return indexQuoteClass(value)
      return ''
    }
  }
}
</script>
<style scoped>
.index-quote-details { flex:none; padding:8px 12px; background:var(--theme-bg); color:var(--theme-label); }
.quote-summary { display:grid; grid-template-columns:repeat(3,minmax(0,1fr)); gap:12px; margin-bottom:10px; }
.quote-summary span { font-size:12px; }.quote-summary strong { display:block; margin-top:4px; font-size:18px; font-weight:500; }
dl { display:grid; grid-template-columns:repeat(3,minmax(0,1fr)); gap:6px 14px; margin:0; font-size:12px; font-variant-numeric:tabular-nums; }
dl > div { display:flex; justify-content:space-between; gap:6px; min-width:0; } dt { color:var(--theme-muted); white-space:nowrap; } dd { margin:0; text-align:right; white-space:nowrap; color:var(--theme-text); }
.detail-controls { display:flex; justify-content:flex-end; gap:12px; margin-top:6px; font-size:12px; color:var(--theme-muted); }
button { padding:2px 0; border:0; background:transparent; color:var(--theme-label); font:inherit; cursor:pointer; } button:focus-visible { outline:2px solid var(--theme-accent); }
.rise { color:var(--quote-up); }.fall { color:var(--quote-down); }
</style>
